module.exports = __webpack_public_path__ + "img/bg.a5515a5e.png";